import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["chip"]

    toggle(event) {
        const chip = event.currentTarget
        const checkbox = chip.querySelector('input[type="checkbox"]')

        if (checkbox) {
            checkbox.checked = !checkbox.checked
            this.updateChipAppearance(chip, checkbox.checked)
        }
    }

    updateChipAppearance(chip, isActive) {
        if (isActive) {
            chip.classList.remove(
                "bg-white/5", "border-white/10", "text-gray-400",
                "hover:bg-white/10", "hover:text-white"
            )
            chip.classList.add(
                "bg-indigo-600/20", "border-indigo-500/50", "text-indigo-300",
                "shadow-[0_0_12px_rgba(99,102,241,0.15)]"
            )
        } else {
            chip.classList.remove(
                "bg-indigo-600/20", "border-indigo-500/50", "text-indigo-300",
                "shadow-[0_0_12px_rgba(99,102,241,0.15)]"
            )
            chip.classList.add(
                "bg-white/5", "border-white/10", "text-gray-400",
                "hover:bg-white/10", "hover:text-white"
            )
        }
    }

    connect() {
        // Set initial appearance based on pre-checked state
        this.chipTargets.forEach((chip) => {
            const checkbox = chip.querySelector('input[type="checkbox"]')
            if (checkbox && checkbox.checked) {
                this.updateChipAppearance(chip, true)
            }
        })
    }
}
